import { __read } from "tslib";
import { useCallback, useEffect, useMemo, useRef, useReducer } from 'react';
import { calculateItemWidth } from './calculateItemWidth';
import { useIsomorphicLayoutEffect } from '../../useIsomorphicLayoutEffect';
export var useAdaptiveTabs = function (props) {
    var tabs = props.tabs, tabsRefs = props.tabsRefs, wrapperRef = props.wrapperRef, moreRef = props.moreRef;
    var _a = __read(useReducer(function (s) { return s + 1; }, 0), 2), forceRender = _a[1];
    var visibleCountRef = useRef(-1);
    var previousTabs = useRef(tabs);
    var tabsWidth = useRef([]);
    // Обнулять состояни нужно именно здесь, чтобы отрендерить все табы и получить их ширины
    // в useIsomorphicLayoutEffect
    if (tabs !== previousTabs.current) {
        visibleCountRef.current = -1;
        previousTabs.current = tabs;
    }
    useIsomorphicLayoutEffect(function () {
        // При первом рендере и при изменении количества табов производим подсчёт ширин
        tabsWidth.current = tabsRefs.map(function (tab) { return calculateItemWidth(tab, true); });
    }, [tabsRefs]);
    var updateVisibleCount = useCallback(function () {
        var wrapperWidth = calculateItemWidth(wrapperRef);
        var totalWidth = tabsWidth.current.reduce(function (acc, tab) { return acc + tab; }, 0);
        var nextVisibleCount = tabsWidth.current.length;
        if (totalWidth > wrapperWidth) {
            nextVisibleCount = 0;
            var sum = calculateItemWidth(moreRef, true);
            while (sum + tabsWidth.current[nextVisibleCount] <= wrapperWidth) {
                sum += tabsWidth.current[nextVisibleCount];
                nextVisibleCount++;
            }
        }
        if (visibleCountRef.current !== nextVisibleCount) {
            visibleCountRef.current = nextVisibleCount;
            forceRender();
        }
        // TODO ISL-10952: разобраться почему не все необходимые переменные указаны в deps и убрать игнор
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useIsomorphicLayoutEffect(function () {
        // На каждый рендер проверяем не поменялось ли количество видимых табов
        updateVisibleCount();
    });
    useEffect(function () {
        window.addEventListener('resize', updateVisibleCount);
        return function () {
            window.removeEventListener('resize', updateVisibleCount);
        };
    }, [updateVisibleCount]);
    var visibleCount = visibleCountRef.current;
    return useMemo(function () {
        if (visibleCount === -1) {
            return [tabs, tabs];
        }
        return [tabs.slice(0, visibleCount), tabs.slice(visibleCount)];
    }, [tabs, visibleCount]);
};
